/* global FileReader */
import { Controller } from '@hotwired/stimulus'
import FlashController from './flash_controller'

export default class WorkorderUploadsController extends Controller {
  static targets = ['input', 'form', 'previewContainer', 'submit', 'overlay', 'content']

  connect () {
    this.files = []
  }

  handleFiles (event) {
    const remaining = this.formTarget.dataset.workorderUploadsRemainingValue
    const remainingValue = parseInt(remaining, 10)

    const selectedFiles = Array.from(event.target.files)
    const allowedCount = remainingValue - this.files.length
    if (allowedCount <= 0) {
      alert(`You can only upload ${remainingValue} image(s) total.`)
      this.inputTarget.value = null
      return
    }

    const filesToAdd = selectedFiles.slice(0, allowedCount)
    this.files = [...this.files, ...filesToAdd]
    this.renderPreviews()
    this.inputTarget.value = null
  }

  renderPreviews () {
    this.previewContainerTarget.innerHTML = ''
    const closeIconMarkup = document.getElementById('close-icon-template').innerHTML.trim()

    this.files.forEach((file, index) => {
      const reader = new FileReader()
      reader.onload = (e) => {
        const wrapper = document.createElement('div')
        wrapper.classList.add('relative', 'inline-block', 'mr-2', 'mb-2')

        wrapper.innerHTML = `
          <img src="${e.target.result}" class="w-32 h-32 object-cover rounded shadow" />
          <button type="button" data-index="${index}"
            class="m-1 absolute top-0 right-0 bg-error-100 text-error-500 rounded-sm w-5 h-5 flex items-center justify-center shadow-md hover:bg-error-200 transition"
            data-action="click->workorder-uploads#removeFile"
            aria-label="Remove image">
            ${closeIconMarkup}
          </button>
        `
        this.previewContainerTarget.appendChild(wrapper)
      }
      reader.readAsDataURL(file)
    })
  }

  removeFile (event) {
    const index = parseInt(event.target.dataset.index)
    this.files.splice(index, 1)
    this.renderPreviews()
  }

  confirmAndSubmit (event) {
    event.preventDefault()
    if (confirm('Are you sure you want to delete this image?')) {
      this.showLoader()
      event.target.closest('form').requestSubmit()
    }
  }

  submitForm (event) {
    event.preventDefault()

    if (this.files.length === 0) {
      alert('Please select at least one image before submitting.')
      return
    }

    const dataTransfer = new DataTransfer()
    this.files.forEach(file => dataTransfer.items.add(file))
    this.inputTarget.files = dataTransfer.files

    const form = this.formTarget
    if (form.checkValidity()) {
      FlashController.prototype.renderFlash('Uploading images, it may take some time.', 'success')
      this.showLoader()
      form.requestSubmit()
    }
  }

  showLoader () {
    if (this.hasOverlayTarget && this.hasContentTarget) {
      this.overlayTarget.classList.remove('hidden')
      this.contentTarget.classList.add('hidden')
    }
  }
}
